var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 9a1 1 0 1 1 0-2h10a1 1 0 0 1 0 2H3z"}));
}

Minus.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Minus;

Minus.default = Minus;
